jQuery(document).ready(function() {
// Set up accordions
   jQuery('.accordion_heading').click(function() {
   if (jQuery(this).parent().is('.open')){
     jQuery(this).closest('.page-accordion').find('.accordion_content_container').animate({'height':'0'},300);
     jQuery(this).closest('.page-accordion').removeClass('open');
     jQuery(this).parent().find('.accordion-button-icon').removeClass('fa-minus').addClass('fa-plus');
   }
   else {
   var newHeight =jQuery(this).closest('.page-accordion').find('.accordion_content').height() + 25 +'px';
     jQuery(this).closest('.page-accordion').find('.accordion_content_container').animate({'height':newHeight},300);
     jQuery(this).closest('.page-accordion').addClass('open');
     jQuery(this).parent().find('.accordion-button-icon').removeClass('fa-plus').addClass('fa-minus');
   }
   });
});
